<template>
  <el-row :gutter="10">
    <el-col :span="9">
      <page-sample-table />
    </el-col>
    <el-col :span="15">
      <page-sample-options-table />
    </el-col>
  </el-row>
</template>
<script>
import PageSampleTable from './components/sampleMetadata-table'
import PageSampleOptionsTable from './components/sampleMetadata-options-table'
export default {
  name: 'master-sampleMetadata',
  components: {
    PageSampleTable,
    PageSampleOptionsTable,
  },
}
</script>
